(function ImageLibrary($, Adzuki)
{
	"use strict";
	var tag_ids = [];

	Adzuki.onload('FitBuilders/imageLibrary', function onload() {
		$('.fit-builder-library-bulk-tag').click(function _bulkAssign(e) {
			var selected = [];

			e.preventDefault();

			$('.item-checkboxes').each(function _getSelected() {
				if ($(this).prop('checked') === true) {
					selected.push($(this).val());
				}
			});

			if (selected.length === 0) {
				Adzuki.StatusMessage("error", "Please select at least one picture to tag.");
			} else {
				document.location = Adzuki.base_uri + '/FitBuilders/bulkTagImages/' + selected.join(',');
			}
		});

		$('.fit-builder-library-delete-items').click(function _deleteSelectedItem(e) {
			var selected = [];

			e.preventDefault();

			Adzuki.CustomConfirm({
				title  : 'Decision Time',
				content: 'Are you sure you want to delete the selected pictures?',
				confirm: function confirm() {
					$('.item-checkboxes').each(function _getSelected() {
						if ($(this).prop('checked') === true) {
							selected.push($(this).val());
						}
					});

					if (selected.length === 0) {
						Adzuki.StatusMessage("error", "Please select at least one item to delete.");
					} else {
						Adzuki.Ajax.post('/FitBuilders/deleteSelectedImages/', {selected: selected})
						.then(function success(content) {
							document.location = Adzuki.base_uri + '/FitBuilders/imageLibrary/';
						});
					}
				}
			});
		});

		$('.fit-builder-library-delete-all-items').click(function _deleteAllSelectedItem(e) {
			e.preventDefault();

			Adzuki.CustomConfirm({
				title  : 'Decision Time',
				content: 'Are you sure you want to delete all the pictures in your library?',
				confirm: function confirm() {
					Adzuki.Ajax.post('/FitBuilders/deleteAllImagesFromLibrary/')
					.then(function success(content) {
						document.location = Adzuki.base_uri + '/FitBuilders/imageLibrary/';
					});
				}
			});
		});

		$('.create-tag-link').click(function _showCreateTag(e) {
			e.preventDefault();

			$('#tag-text').removeClass('hidden');
			$('#tag-list').addClass('hidden');
		});

		$('.fitbuildercomponentimagelibrary-task-tag-cancel-btn').click(function _showTagList(e) {
			e.preventDefault();

			$('#tag-text').addClass('hidden');
			$('#tag-list').removeClass('hidden');
		});

		$('.fitbuildercomponentimagelibrary-task-tag-save-btn').on('click', function _createTagClick(e) {
			var tag_name = $('#fitbuildercomponentimagelibrary-create_tag').val().trim();

			e.preventDefault();

			if (!tag_name) {
				Adzuki.StatusMessage('error', 'A name for the tag must be provided');
				return;
			}

			if (tag_name.length < 2) {
				Adzuki.StatusMessage('error', 'The name of the tag must be at least 2 characters');
				return;
			}

			Adzuki.Ajax.post('/FitBuilders/createTag', { name: tag_name }).then(
				function success(response) {
					// var tag_key  = response.id + '|' + response.color + '|' + response.text_color;
					var tag_name = response.name,
						tag_key  = response.id;

					// insert new tag and clear the contents of the field
					_insertTag(tag_key, tag_name);
					// $('#' + form_id + 'create_tag').val('');

					Adzuki.StatusMessage('success', 'The tag has been created successfully');
				}
			);
		});

		$('#fitbuildercomponentimagelibrary-tags').change(function _addTag() {
			var $selected = $('#fitbuildercomponentimagelibrary-tags option:selected');
			_insertTag($selected.val(), $selected.text());
		});

		$('.tag-selection').on('click', '.remove-tag', function _removeTag(e) {
			var tag_id      = $(this).data('tag-id'),
				$remove_btn = $(this),
				tag_ids_str = $('#fitbuildercomponentimagelibrary-tag_ids').val(),
				tag_ids     = tag_ids_str.split(',');

			e.preventDefault();

			$.each(tag_ids, function onEachTagId(i, id) {
				if (tag_id === parseInt(id)) {
					tag_ids.splice(i, 1);
					return false; // break
				}
			});

			if (tag_ids.length > 0) {
				tag_ids_str = tag_ids.join(',');
			} else {
				tag_ids_str = '';
			}

			// update ids in hidden field and remove tag from markup
			$('#fitbuildercomponentimagelibrary-tag_ids').val(tag_ids_str);
			$remove_btn.parent().remove();
				e.preventDefault();
		});

		$('.fb-library-check').click(function _checkUncheckAll(e) {
			var state = $(this).data('state'),
				$obj  = $(this);

			e.preventDefault();

			if (state === 'unchecked') {
				$('.item-checkboxes').each(function _takeItToTheMaxx() {
					$(this).prop('checked', true);
				});

				$obj.data('state', 'checked');
			} else {
				$('.item-checkboxes').each(function _takeItToTheMaxx() {
					$(this).prop('checked', false);
				});

				$obj.data('state', 'unchecked');
			}
		});
	});

	function _insertTag(tag_id, tag_name)
	{
		var icon           = Adzuki.FaIcon.getIconStyle('delete_not_red', 'solid'),
			tag_ids_str    = $('#fitbuildercomponentimagelibrary-tag_ids').val(),
			tag_markup     = '';

		// build markup for the selected tag
		tag_markup += '<span class="tag" style="border-color: #0080c5; background-color: #0080c5;">';
		tag_markup += '<span style="cursor:pointer;" class="remove-tag" data-tag-id="' + tag_id + '">';
		tag_markup += '<i class="adzicon-delete_not_red ' + icon + '" style="color: #FFF;"></i></span>';
		tag_markup += '<span class="title" style="color: #FFF;;">';
		tag_markup += ' ' + tag_name + '</span>';
		tag_markup += '</span>';

		$('.tags').append(tag_markup);

		tag_ids.push(tag_id);
		tag_ids_str = tag_ids.join(',');

		$('#fitbuildercomponentimagelibrary-tag_ids').val(tag_ids_str);
	}
}(jQuery, window.Adzuki || {}));